import { Images } from '../../assets/scripts/Images'
import React, { useEffect, useState } from 'react'

function ErrorTemplate({ error_code }) {
  const token = localStorage.getItem('Token')
  const [isToken, setIsToken] = useState(false)
  let ERROR_TEXT = {
    404: ' متاسفانه صفحه مورد نظر یافت نشد',
    500: 'خطایی سمت سرور رخ داد لطفا دوباره تلاش کنید',
  }

  useEffect(() => {
    async function fetchData() {
      setIsToken(token)
    }

    fetchData()
  }, [])
  const backToDashboard = () => {
    if (token) {
      window.location.href = '/dashboard'
    } else {
      window.location.href = '/login'
    }
  }

  let position_center = 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
  let position_center_mobile = 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'

  return (
    <div className={`${isToken ? 'w-full h-screen-top' : 'w-screen h-screen'} relative`}>
      <img
        src={Images.left_top_pattern}
        className={'hidden lg:block absolute top-0 left-0'}
        alt="left pattern"
      />
      <img src={Images.icon_logo} className={position_center_mobile} alt="error logo background" />
      <div className={`flex flex-col items-center justify-center ${position_center}`}>
        <h1 className={'text-8xl font-bold dark:text-amber-50'}>{error_code}</h1>
        <p className={'font-medium text-base dark:text-slate-200'}>{ERROR_TEXT[error_code]}</p>
      </div>

      <button
        onClick={backToDashboard}
        className="absolute bottom-20 left-1/2 -translate-x-1/2 flex items-center"
      >
        <span className={'text-secondary pl-3 text-lg font-semibold'}>
          بازگشت به {token ? 'داشبورد' : 'صفحه ورود'}
        </span>
        <i className={'icon-arrow-left text-base text-white bg-secondary rounded-md py-0 px-1'} />
      </button>

      <img
        src={Images.right_bottom_pattern}
        className={'hidden lg:block absolute bottom-0 right-0'}
        alt="right pattern"
      />
    </div>
  )
}

export default React.memo(ErrorTemplate)
